import { SerializedStyles, StyledProps, Theme } from '@emotion/react';

/**
 * Allows to add styles for only a particular
 * project by providing a theme `name`
 */
export const themeStyles =
    (name: Theme['version'], styles: SerializedStyles) =>
    ({ theme }: StyledProps) =>
        theme.version === name && styles;
